import { Component, ElementRef } from '@angular/core';
import { IWizItemRenderer, WizBaseCollector } from '@wizeoo/akm-component-lib';
import { VisionKeyObj } from '@wizeoo/akm-common-lib';

@Component({
  selector: 'ordered-vision-key-renderer',
  template: `
    <wiz-hgroup width="100%" height="100%" verticalAlign="center" style="padding-left:5px; padding-right:5px">
      <wiz-label [wizLabel]="data.orderAndlabel" width="100%"></wiz-label>
      <wiz-icon *ngIf="data.isChronocode">chronocodes</wiz-icon>
    </wiz-hgroup>
  `,
})
export class OrderedVisionKeyRenderer implements IWizItemRenderer<null, VisionKeyObj> {
  constructor(public elementRef: ElementRef) {}

  data: VisionKeyObj;
  owner: WizBaseCollector;
}
